import { Config } from 'core/common/contexts';
import { ObservabilitySystem } from 'core/common/observability/interfaces';
import { Logger } from 'core/common/services/logger/interfaces';
import { StorageInterface } from '../storage';
import { AxiosHttpClient } from './AxiosHttpClient';
import { HttpClientWithObservability } from './HttpClientWithObservability';
import { HttpClientWithPersistentHeaders } from './HttpClientWithPersistentHeaders';
import { HttpClientWithRequestId } from './HttpClientWithRequestId';
import { HttpClientWithRetry } from './HttpClientWithRetry';
import { HttpRequestConfig } from './entities';
import { HttpClient } from './interfaces';

export class HttpClientBuilder {
  private httpClient: HttpClient;

  constructor(apiUrl: string, config?: HttpRequestConfig) {
    this.httpClient = new AxiosHttpClient(apiUrl, config);
  }

  addObservability(observabilitySystem: ObservabilitySystem) {
    this.httpClient = new HttpClientWithObservability(this.httpClient, observabilitySystem);

    return this;
  }

  addPersistentHeaders(storage: StorageInterface, fallbackStorage?: StorageInterface) {
    this.httpClient = new HttpClientWithPersistentHeaders(
      this.httpClient,
      storage,
      fallbackStorage,
    );

    return this;
  }

  addRequestId() {
    this.httpClient = new HttpClientWithRequestId(this.httpClient);

    return this;
  }

  addRetry(logger: Logger, config: Config) {
    this.httpClient = new HttpClientWithRetry(this.httpClient, logger, config);

    return this;
  }

  getResult() {
    return this.httpClient;
  }
}
